import { render, staticRenderFns } from "./TextileReport.vue?vue&type=template&id=94b032ea&scoped=true"
import script from "./TextileReport.vue?vue&type=script&lang=js"
export * from "./TextileReport.vue?vue&type=script&lang=js"
import style0 from "./TextileReport.vue?vue&type=style&index=0&id=94b032ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94b032ea",
  null
  
)

export default component.exports